export default __webpack_public_path__ + "static/media/login-title-cn.c905f043.svg";